// extracted by mini-css-extract-plugin
export default {"cardGrid":"WhitepaperIndex-module__cardGrid--RFCPZ"};